import { useState } from "react";

const UserDepartmentReadOnlyRow = ({ index, t, userDeptItem, handleDeleteClick, oddIdx, add, setError, handleSubmit }) => {
	const [isSubmit, setIsSubmit] = useState(false);

	function submitComplete() {
		setIsSubmit(false);
	}

	function submitDelete(event, userDeptItem) {
		setError("");
		setIsSubmit(true);
		handleDeleteClick(event, userDeptItem, submitComplete);
	}

	return (
		<tr key={index}>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userDeptItem.departmentName}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userDeptItem.departmentType}</td>
			<td className={oddIdx ? "list-td col text-wrap odd" : "list-td col text-wrap even"}>{userDeptItem.address}</td>
			<td className={oddIdx ? "list-td col odd" : "list-td col even"}>{userDeptItem.status}</td>
			<td className={oddIdx ? "list-td col col-md-auto odd" : "list-td col col-md-auto even"}>
				<div id="submit-spinner"
					className={isSubmit ? "spinner-border spinner-border-sm text-dark spinner-size" : "spinner-hide"}
				>
				</div>
				<button className={isSubmit ? "btn btn-primary btn-block me-4 pe-none" : "btn btn-primary btn-block"} onClick={(event) => submitDelete(event, userDeptItem)}>
					{userDeptItem.statusCode === 1 ? t("page.delete") : t("page.undelete")}</button>
			</td>
		</tr>
	)
}
export default UserDepartmentReadOnlyRow;